module.exports = __webpack_public_path__ + "static/media/casar.7eb676ce.png";